<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">


      <div class="col-md-8">

        <img src="/assets/img/logo.png"/>

        <div class="card-group mb-4">

          <div class="card p-4">
            <div class="card-body">
              <h1>Login</h1>

              <p class="text-muted">Sign In to your account</p>
              <div class="input-group mb-3">
                <span class="input-group-addon"><i class="icon-user"></i></span>
                <input type="text" class="form-control" placeholder="Username" [(ngModel)]="model.username" required value="">
              </div>
              <div class="input-group mb-4">
                <span class="input-group-addon"><i class="icon-lock"></i></span>
                <input type="password" class="form-control" placeholder="Password"
                       [(ngModel)]="model.password" required value="">
              </div>
              <div class="row">
                <div class="col-6">
                  <button type="button" class="btn btn-primary px-4" (click)="login()">Login</button>
                </div>
                <div class="col-6 text-right">
                  <button type="button" class="btn btn-link px-0" onclick="location.href='/#/pages/reset/init'">Forgot password?</button>
                </div>
              </div>
            </div>


          </div>
          <div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%">
            <div class="card-body text-center">
              <div>
                <h2>Sign up</h2>
                <p>
                  <br/>
                  See your visitors in real time with <b>ExtraWatch<sup>&reg;</sup></b>
                  <br/>
                  <br/>
                  <br/>
                </p>

                <button type="button" class="btn btn-primary active mt-3" onclick="location.href='/#/pages/register'">Register Now!</button>

              </div>
            </div>
          </div>
        </div>
        <!--
        <div *ngIf="errorMessage?.length > 0" style="width: 100%; text-align: justify; color: gray; font-style: italic; text-justify: inter-word;">
          * If you can't login and want to access ExtraWatch PRO membership page, please use
          <a href="https://www.extrawatch.com/component/rsmembership/view-my-memberships">this link</a>
        </div>
        -->

      </div>
    </div>
  </div>
</div>

